import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NewsItem } from './NewsItem';
import BreadCrumbs from '../../components/BreadСrumbs/BreadСrumbs';
import { getNewsFeed } from '../../utils/api/services/news';
import paths from '../../paths';
import Preloader from '../../components/Preloader/Preloader';
import ListFooter from '../../components/ListFooter/ListFooter';
import { setUrlParameters } from '../../utils/helpers'; 
import { getPage } from '../../utils/urlHelper'; 

export class NewsList extends Component {
  constructor(props) {
    super(props);

    this.pageSize = 5;
    
    this.state = {
      isLoading: true,
      news: [],
      total: 0,
    };
  }

  componentWillMount = () => {
    this.fetchData();
  };

  fetchData = () => {
    const page = getPage();

    this.setState({ isLoading: true });
    getNewsFeed((page - 1) * this.pageSize, this.pageSize)
      .then((result) => {
        this.setState({
          news: result.data,
          total: result.total,
        });
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  handlePageClick = (e) => {
    const newPage = e.selected + 1;
    let urlQuery = {};
    urlQuery["page"] = newPage > 1 ? newPage : null;
    setUrlParameters(urlQuery, this.fetchData);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.location.search !== this.props.location.search) {
      this.fetchData();
    }
  }

    handleLoadMore = () => {
        const page = getPage();
        const newPage = page + 1;
        let urlQuery = {};
        urlQuery["page"] = newPage > 1 ? newPage : null;
        setUrlParameters(urlQuery);

        this.setState({ isLoading: true });
        getNewsFeed(page * this.pageSize, this.pageSize)
            .then((result) => {
                this.setState({
                    news: [...this.state.news, ...result.data],
                    total: result.total,
                });
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                this.setState({
                    isLoading: false,
                });
            });
    };

  render() {
    const {
      isLoading, news, total, 
    } = this.state;

    const page = getPage();

    if (isLoading && !news.length) {
      return <Preloader />;
    }

    return (
      <div className="b-center bg-dragonfly5">
        <BreadCrumbs
          data={[{ url: paths.advocates.main, text: 'Главная' }, { url: paths.advocates.main, text: 'Все новости' }]}
        />

        <h1 className="title -secondary">Все новости</h1>

        {news.length ? (
          <NewsListContent
            news={news}
            total={total}
            pageSize={this.pageSize}
            currentPage={page}
            handleLoadMore={this.handleLoadMore}
            handlePageClick={this.handlePageClick}
          />
        ) : (
          <div>Новостей нет :(</div>
        )}
      </div>
    );
  }
}

const NewsListContent = ({
  news, pageSize, total, handlePageClick, currentPage, handleLoadMore
}) => (
  <React.Fragment>
    <div className="news__list">
      {news.length ? (
        news.map(item => (
          <NewsItem
            key={item.id}
            alias={item.alias}
            title={item.title}
            announce={item.announce}
            date={item.createdDate}
          />
        ))
      ) : (
        <div>Новостей нет</div>
      )}
    </div>

    <ListFooter
      counterLabel="новостей"
      pageSize={pageSize}
      currentPage={currentPage}
      total={total}
      handleLoadMore={handleLoadMore}
      handlePageClick={handlePageClick}
    />
  </React.Fragment>
);
